import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import PlanComparisonTable from "../../../V2/Sections/PlanComparisonTable"

const StoryblokPlanComparisonTable = ({
  blok,
}: Storyblok.BlokProps<Storyblok.PlanComparisonTable>) => {
  const blokHeading = blok.heading?.[0]

  return (
    <PlanComparisonTable
      sectionId={blok._uid}
      backgroundColor={blok.backgroundColor}
      innerBackgroundColor={blok.innerBackgroundColor}
      heading={
        blokHeading
          ? {
              ...blokHeading,
              size: blokHeading.size || "large",
              callout: blokHeading.callout?.[0],
            }
          : undefined
      }
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokPlanComparisonTable
